module.exports = __webpack_public_path__ + "img/1540626647.e0d87f55.jpg";